class MyCartHandler {
  constructor() {
    this.init();
  }

  init() {
    const buttons = document.querySelectorAll('[data-quick-buy]');
    buttons.forEach(button => {
      button.addEventListener('click', (event) => this._addToCart(event, button));
    });
  }

  _addToCart(event, button) {
    event.stopPropagation();

    this._setAtcButtonProcessing(button);

    const variantId = button.getAttribute('data-variant-id');
    if (!variantId) {
      console.error('Variant ID not found');
      this._showErrorBanner('Invalid product variant.');
      this._removeAtcButtonProcessing(button);
      return;
    }

    const formData = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };

    fetch(`/cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Add to cart failed');
        }
        return response.json();
      })
      .then(() => {
        // ✅ Redirect to cart page on success
        window.location.href = window.Theme?.routes?.cart_url || '/cart';
      })
      .catch(error => {
        console.error('Add to Cart Error:', error);
        this._removeAtcButtonProcessing(button);
        this._showErrorBanner('Could not add product to cart.');
      });
  }

  _setAtcButtonProcessing(button) {
    button.classList.add('processing');
    button.disabled = true;
  }

  _removeAtcButtonProcessing(button) {
    button.classList.remove('processing');
    button.disabled = false;
  }

  _showErrorBanner(msg) {
    // 🔔 Basic banner – can be replaced with a better UI if needed
    const banner = document.createElement('div');
    banner.textContent = msg;
    banner.style.position = 'fixed';
    banner.style.top = '20px';
    banner.style.left = '50%';
    banner.style.transform = 'translateX(-50%)';
    banner.style.padding = '12px 20px';
    banner.style.backgroundColor = '#ff4d4f';
    banner.style.color = '#fff';
    banner.style.zIndex = '9999';
    banner.style.borderRadius = '5px';
    document.body.appendChild(banner);

    setTimeout(() => {
      banner.remove();
    }, 3000);
  }
}

if (window.Theme && typeof window.Theme.syncReturningCustomerSession === 'function') {
  window.Theme.syncReturningCustomerSession();
}

var RECENTLY_VIEWED_MAX_STORAGE_TIME = 30 * 24 * 3600;
var RECENTLY_VIEWED_MAX_ITEMS = 30;
var HUB_RECENT_PRODUCTS_KEY = 'hub-recent-products';

function getRecentlyViewedStorageKey(theme) {
  var currency = theme.currency || '';
  var rootUrl = theme.routes && theme.routes.root_url ? theme.routes.root_url : '/';
  return 'pxu-recentlyViewed-' + currency + '-' + rootUrl;
}

function getRecentlyViewedItems(theme) {
  try {
    var storageKey = getRecentlyViewedStorageKey(theme);
    var items = JSON.parse(localStorage.getItem(storageKey) || '[]');
    var now = Math.floor(Date.now() / 1000);
    var minTimestamp = now - RECENTLY_VIEWED_MAX_STORAGE_TIME;

    return items.filter(function(item) {
      return item && item.handle && item.timestamp > minTimestamp;
    });
  } catch (error) {
    return [];
  }
}

function saveRecentlyViewedItems(theme, items) {
  var storageKey = getRecentlyViewedStorageKey(theme);
  var trimmedItems = items.slice(-RECENTLY_VIEWED_MAX_ITEMS);

  try {
    localStorage.setItem(storageKey, JSON.stringify(trimmedItems));
  } catch (error) {}
}

function addRecentlyViewedProduct(theme, handle) {
  if (!handle) {
    return;
  }

  var items = getRecentlyViewedItems(theme).filter(function(item) {
    return item.handle !== handle;
  });

  items.push({
    handle: handle,
    timestamp: Math.floor(Date.now() / 1000)
  });

  saveRecentlyViewedItems(theme, items);
}

function syncHubRecentProductsToEmpire(theme) {
  try {
    var hubRaw = localStorage.getItem(HUB_RECENT_PRODUCTS_KEY);
    if (!hubRaw) {
      return;
    }

    var hubHandles = JSON.parse(hubRaw);
    if (!Array.isArray(hubHandles) || !hubHandles.length) {
      return;
    }

    var items = getRecentlyViewedItems(theme);
    var now = Math.floor(Date.now() / 1000);

    hubHandles.forEach(function(handle, index) {
      if (!handle || typeof handle !== 'string') {
        return;
      }

      items = items.filter(function(item) {
        return item.handle !== handle;
      });

      items.push({
        handle: handle,
        timestamp: now - index
      });
    });

    saveRecentlyViewedItems(theme, items);
  } catch (error) {}
}

function getProductHandleFromPage(theme) {
  if (theme.currentProductHandle) {
    return theme.currentProductHandle;
  }

  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : null;
}

function trackCurrentProductPageView() {
  if (!document.body.classList.contains('template-product')) {
    return;
  }

  var theme = window.Theme || {};
  var handle = getProductHandleFromPage(theme);

  if (handle) {
    addRecentlyViewedProduct(theme, handle);
  }
}

function getRecentlyViewedCount(theme) {
  syncHubRecentProductsToEmpire(theme);
  return getRecentlyViewedItems(theme).length;
}

var HOMEPAGE_RECENTLY_VIEWED_PRODUCT_LIMIT = 5;
var HOMEPAGE_FEATURED_RV_TITLE = 'Recently Viewed Products';
var homepageFeaturedOriginalState = null;

function getHomepageProductCardFetchUrl(handle, theme) {
  var rootUrl = theme.routes && theme.routes.root_url ? theme.routes.root_url : '/';
  var normalizedRoot = rootUrl === '/' ? '' : rootUrl.replace(/\/$/, '');
  return normalizedRoot + '/products/' + handle + '?view=homepage-grid';
}

function getHomepageFeaturedCollectionEl() {
  return document.querySelector('[data-homepage-featured-collection] [data-featured-collection]');
}

function captureHomepageFeaturedOriginalState() {
  if (homepageFeaturedOriginalState) {
    return;
  }

  var featured = getHomepageFeaturedCollectionEl();

  if (!featured) {
    return;
  }

  var titleEl = featured.querySelector('.home-section--title');
  var carousel = featured.querySelector('[data-content]');

  if (!carousel) {
    return;
  }

  homepageFeaturedOriginalState = {
    title: titleEl ? titleEl.textContent.trim() : '',
    carouselHtml: carousel.innerHTML,
    layout: carousel.dataset.layout || 'grid',
    mobileLayout: carousel.dataset.mobileLayout || 'slideshow'
  };
}

function destroyCarouselFlickity(carousel) {
  if (!carousel || !window.Flickity) {
    return;
  }

  var flickity = window.Flickity.data(carousel);

  if (flickity) {
    flickity.destroy();
  }
}

function applyHomepageRecentlyViewedGridLayout(carousel, featured) {
  if (!carousel) {
    return;
  }

  destroyCarouselFlickity(carousel);
  carousel.dataset.layout = 'grid';
  carousel.dataset.mobileLayout = 'grid';
  carousel.classList.remove('flickity-enabled');

  if (featured) {
    featured.classList.add('homepage-recently-viewed-grid');

    featured.querySelectorAll('.product-carousel-wrapper .arrow').forEach(function(button) {
      button.style.display = 'none';
    });
  }

  window.dispatchEvent(new Event('resize'));
}

function setHomepageFeaturedTitle(showRecentlyViewed) {
  var featured = getHomepageFeaturedCollectionEl();

  if (!featured || !homepageFeaturedOriginalState) {
    return;
  }

  var titleEl = featured.querySelector('.home-section--title');

  if (!titleEl) {
    return;
  }

  titleEl.textContent = showRecentlyViewed
    ? HOMEPAGE_FEATURED_RV_TITLE
    : homepageFeaturedOriginalState.title;
}

function finishHomepageFeaturedSwap(didSwap) {
  var html = document.documentElement;

  if (!html.classList.contains('homepage-featured-swap-pending')) {
    return;
  }

  if (didSwap) {
    html.classList.add('homepage-featured-swap-ready');
  }

  html.classList.remove('homepage-featured-swap-pending');
}

function hydrateHomepageProductImages(container) {
  if (!container) {
    return;
  }

  container.querySelectorAll('.productitem--image img').forEach(function(img) {
    var lazyState = img.getAttribute('data-rimg');
    var srcset = img.getAttribute('srcset') || '';
    var needsHydration = lazyState === 'lazy'
      || lazyState === 'loading'
      || srcset.indexOf('data:image/svg') !== -1;

    if (needsHydration) {
      var figure = img.closest('figure');
      var noscriptImg = figure ? figure.querySelector('noscript img') : null;

      if (noscriptImg) {
        img.src = noscriptImg.getAttribute('src') || noscriptImg.src;

        var noscriptSrcset = noscriptImg.getAttribute('srcset');

        if (noscriptSrcset) {
          img.srcset = noscriptSrcset;
        }
      } else {
        var template = img.getAttribute('data-rimg-template');

        if (template) {
          img.src = template.replace(/\{size\}/g, '512x512');
          img.srcset = [
            template.replace(/\{size\}/g, '512x512') + ' 1x',
            template.replace(/\{size\}/g, '1024x1024') + ' 2x'
          ].join(', ');
        }
      }
    }

    img.setAttribute('data-rimg', 'loaded');
    img.removeAttribute('data-rimg-template');
    img.removeAttribute('data-rimg-scale');
    img.removeAttribute('data-rimg-max');
    img.removeAttribute('data-rimg-crop');
    img.style.opacity = '1';

    if (img.classList.contains('productitem--image-primary')) {
      img.style.visibility = 'visible';
    }
  });

  container.querySelectorAll('[data-rimg-canvas]').forEach(function(canvas) {
    canvas.remove();
  });
}

function initHomepageInjectedProductCards(container) {
  hydrateHomepageProductImages(container);

  window.requestAnimationFrame(function() {
    hydrateHomepageProductImages(container);
  });
}

function getHomepageRecentlyViewedMarkups(handles, theme) {
  function fetchAllMarkups() {
    return Promise.all(handles.map(function(handle) {
      return fetchHomepageProductGridCard(handle, theme);
    }));
  }

  if (window.__homepageRvCardPromises && window.__homepageRvCardPromises.length) {
    var promises = window.__homepageRvCardPromises;
    window.__homepageRvCardPromises = null;

    return Promise.all(promises).then(function(markups) {
      var hasLazyMarkup = markups.some(function(markup) {
        return markup && markup.indexOf('data-rimg="lazy"') !== -1;
      });

      if (hasLazyMarkup) {
        return fetchAllMarkups();
      }

      return markups;
    });
  }

  return fetchAllMarkups();
}

function fetchHomepageProductGridCard(handle, theme) {
  var fetchUrl = getHomepageProductCardFetchUrl(handle, theme);

  return fetch(fetchUrl)
    .then(function(response) {
      return response.text();
    })
    .then(function(html) {
      if (!html || html.indexOf('productgrid--item') === -1) {
        return '';
      }

      return html;
    })
    .catch(function() {
      return '';
    });
}

function populateHomepageFeaturedWithRecentlyViewed() {
  var featured = getHomepageFeaturedCollectionEl();
  var carousel = featured ? featured.querySelector('[data-content]') : null;

  if (!carousel || carousel.dataset.recentlyViewedPopulated === 'true') {
    return Promise.resolve(false);
  }

  captureHomepageFeaturedOriginalState();

  var theme = window.Theme || {};
  var items = getRecentlyViewedItems(theme);

  if (!items.length) {
    finishHomepageFeaturedSwap(false);
    return Promise.resolve(false);
  }

  var handles = items
    .slice(-HOMEPAGE_RECENTLY_VIEWED_PRODUCT_LIMIT)
    .reverse()
    .map(function(item) {
      return item.handle;
    });

  return getHomepageRecentlyViewedMarkups(handles, theme).then(function(markups) {
    var validMarkup = markups.filter(function(markup) {
      return markup && markup.indexOf('productgrid--item') !== -1;
    });

    if (!validMarkup.length) {
      finishHomepageFeaturedSwap(false);
      return false;
    }

    destroyCarouselFlickity(carousel);
    carousel.innerHTML = validMarkup.slice(0, HOMEPAGE_RECENTLY_VIEWED_PRODUCT_LIMIT).join('');
    carousel.dataset.recentlyViewedPopulated = 'true';
    initHomepageInjectedProductCards(carousel);
    applyHomepageRecentlyViewedGridLayout(carousel, featured);
    setHomepageFeaturedTitle(true);
    finishHomepageFeaturedSwap(true);

    setTimeout(function() {
      if (carousel.dataset.recentlyViewedPopulated === 'true') {
        initHomepageInjectedProductCards(carousel);
        applyHomepageRecentlyViewedGridLayout(carousel, featured);
      }
    }, 750);

    if (window.innerWidth <= 990) {
      new MyCartHandler();
    }

    return true;
  });
}

function runHomepageProductBlockSwapWhenReady() {
  if (!document.body.classList.contains('template-index')) {
    return;
  }

  captureHomepageFeaturedOriginalState();

  var theme = window.Theme || {};
  var isReturningCustomer = false;

  try {
    isReturningCustomer = sessionStorage.getItem('returning_customer') === 'true';
  } catch (error) {}

  var recentlyViewedCount = getRecentlyViewedCount(theme);

  if (!isReturningCustomer || recentlyViewedCount === 0) {
    finishHomepageFeaturedSwap(false);
    return;
  }

  populateHomepageFeaturedWithRecentlyViewed().then(function(success) {
    if (!success) {
      finishHomepageFeaturedSwap(false);
    }
  });
}

function getStickyCollectionUtilsTop() {
  var header = document.querySelector('.site-header');
  var announcement = document.querySelector('.announcement-top-new, .announcement-bar');
  var offset = header ? header.offsetHeight : 0;

  if (announcement) {
    offset += announcement.offsetHeight;
  }

  if (header) {
    var headerBottom = header.getBoundingClientRect().bottom;

    if (headerBottom > 0) {
      offset = Math.round(headerBottom);
    }
  }

  return offset;
}

function positionStickyCollectionUtils() {
  var utils = document.querySelector('[data-sticky-utils]');
  var sentinel = document.querySelector('[data-utils-intersection-target]');

  if (!utils) {
    return;
  }

  if (window.innerWidth > 859) {
    utils.style.top = '';
    document.documentElement.style.removeProperty('--collection-utils-top');
    if (sentinel) {
      sentinel.style.top = '';
    }
    hideCollectionUtilsProxy();
    return;
  }

  var top = getStickyCollectionUtilsTop();
  var topPx = top + 'px';

  document.documentElement.style.setProperty('--collection-utils-top', topPx);
  utils.style.top = topPx;

  if (sentinel) {
    sentinel.style.top = '-' + topPx;
  }

  syncCollectionUtilsProxy();
}

var utilsProxy = null;

function createCollectionUtilsProxy() {
  if (utilsProxy) {
    return utilsProxy;
  }

  utilsProxy = document.createElement('div');
  utilsProxy.setAttribute('data-utils-proxy', '');
  utilsProxy.style.cssText = 'position:fixed;left:0;right:0;z-index:99999;pointer-events:none;display:none;';
  document.body.appendChild(utilsProxy);

  utilsProxy.addEventListener('click', function (e) {
    if (document.body.classList.contains('modal-visible') ||
        document.querySelector('.site-mobile-nav[data-open="true"]')) {
      hideCollectionUtilsProxy();
      return;
    }

    var x = e.clientX;
    var y = e.clientY;
    var buttons = document.querySelectorAll('.utils-filter-button, .utils-sortby-button, .utils-viewtoggle-button');

    for (var i = 0; i < buttons.length; i++) {
      var r = buttons[i].getBoundingClientRect();

      if (r.width < 2 || r.height < 2) {
        continue;
      }

      if (x >= r.left && x <= r.right && y >= r.top && y <= r.bottom) {
        e.preventDefault();
        e.stopPropagation();
        buttons[i].click();
        return;
      }
    }
  });

  return utilsProxy;
}

function syncCollectionUtilsProxy() {
  var utils = document.querySelector('[data-sticky-utils]');

  if (!utils || window.innerWidth > 859) {
    hideCollectionUtilsProxy();
    return;
  }

  var rect = utils.getBoundingClientRect();
  var headerBottom = getStickyCollectionUtilsTop();
  var isStuck = rect.top <= headerBottom + 2;

  if (!isStuck) {
    hideCollectionUtilsProxy();
    return;
  }

  var proxy = createCollectionUtilsProxy();

  proxy.style.top = Math.round(rect.top) + 'px';
  proxy.style.height = Math.round(rect.height) + 'px';
  proxy.style.display = 'block';
  proxy.style.pointerEvents = 'auto';
}

function hideCollectionUtilsProxy() {
  if (utilsProxy) {
    utilsProxy.style.display = 'none';
    utilsProxy.style.pointerEvents = 'none';
  }
}

function initStickyCollectionUtils() {
  positionStickyCollectionUtils();

  window.addEventListener('resize', positionStickyCollectionUtils);
  window.addEventListener('scroll', positionStickyCollectionUtils, { passive: true });
  document.addEventListener('scroll', positionStickyCollectionUtils, { passive: true, capture: true });

  var header = document.querySelector('.site-header, [data-site-header]');
  if (header) {
    header.addEventListener('transitionend', positionStickyCollectionUtils);
  }

  window.setTimeout(positionStickyCollectionUtils, 100);
  window.setTimeout(positionStickyCollectionUtils, 400);

  new MutationObserver(function () {
    if (document.body.classList.contains('modal-visible') ||
        document.body.classList.contains('scroll-locked') ||
        document.querySelector('.site-mobile-nav[data-open="true"]')) {
      hideCollectionUtilsProxy();
    } else {
      syncCollectionUtilsProxy();
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
}

function isCollectionPage() {
  if (document.body && document.body.classList.contains('template-collection')) {
    return true;
  }

  return /^\/collections(\/|$)/.test(window.location.pathname);
}

function klaviyoPopupIsVisible(root) {
  var scope = root && root.querySelector ? root : document;
  var popup = scope.querySelector('[data-testid="POPUP"], [data-testid="FLYOUT"], form.klaviyo-form');

  if (!popup) {
    return false;
  }

  var styles = window.getComputedStyle(popup);

  if (styles.display === 'none' || styles.visibility === 'hidden' || parseFloat(styles.opacity) === 0) {
    return false;
  }

  var rect = popup.getBoundingClientRect();

  return rect.width > 40 && rect.height > 40;
}

function unlockKlaviyoCollectionScroll() {
  var body = document.body;
  var html = document.documentElement;

  if (html) {
    html.classList.remove('klaviyo-prevent-body-scrolling');
  }

  if (body) {
    body.classList.remove('klaviyo-prevent-body-scrolling');
  }
}

function initBlockKlaviyoPopupsOnCollections() {
  if (!isCollectionPage() || !document.body) {
    return;
  }

  unlockKlaviyoCollectionScroll();

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      unlockKlaviyoCollectionScroll();
    });
  });

  observer.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });
}

function releaseHiddenKlaviyoOverlay() {
  document.querySelectorAll('div.needsclick, div[class*="kl-private-reset"]').forEach(function (el) {
    var styles = window.getComputedStyle(el);
    var rect = el.getBoundingClientRect();
    var coversPage = rect.width >= window.innerWidth * 0.75 && rect.height >= window.innerHeight * 0.75;
    var shell = el.closest('div.needsclick') || el;
    var popupOpen = klaviyoPopupIsVisible(shell);

    if (coversPage && !popupOpen) {
      el.style.setProperty('pointer-events', 'none', 'important');
      return;
    }

    if (popupOpen && el.style.pointerEvents === 'none') {
      el.style.removeProperty('pointer-events');
    }
  });

  if (klaviyoPopupIsVisible(document)) {
    return;
  }

  document.querySelectorAll('[kl-aria-hidden="true"]').forEach(function (el) {
    el.removeAttribute('kl-aria-hidden');
    el.removeAttribute('aria-hidden');
  });
}

var collectionUtilsModal = {
  source: null,
  handle: ''
};

function getCollectionUtilsModalEls() {
  var modal = document.querySelector('[data-modal-container]');

  if (!modal) {
    return null;
  }

  return {
    modal: modal,
    inner: modal.querySelector('[data-modal-inner]'),
    content: modal.querySelector('[data-modal-content]'),
    close: modal.querySelector('[data-modal-close]')
  };
}

function moveCollectionUtilsModalNodes(from, to) {
  if (!from || !to) {
    return;
  }

  while (from.firstChild) {
    to.appendChild(from.firstChild);
  }
}

function positionCollectionUtilsModal() {
  var els = getCollectionUtilsModalEls();

  if (!els || !els.inner) {
    return;
  }

  var modalHeight = els.inner.offsetHeight;
  var modalPadding = parseInt(window.getComputedStyle(els.modal).paddingTop, 10) * 2;
  var offset = (window.innerHeight - modalPadding - modalHeight) / 2;

  els.inner.style.marginTop = (offset > 0 ? offset : 0) + 'px';
}

function closeCollectionUtilsModal() {
  var els = getCollectionUtilsModalEls();

  if (!els || !collectionUtilsModal.source) {
    return;
  }

  document.body.classList.remove('modal-visible', 'modal-loaded');
  els.modal.classList.remove('modal--' + collectionUtilsModal.handle);
  els.inner.style.marginTop = '';
  moveCollectionUtilsModalNodes(els.content, collectionUtilsModal.source);
  collectionUtilsModal.source = null;
  collectionUtilsModal.handle = '';
  document.body.style.removeProperty('overflow');
}

function openCollectionUtilsModal(sourceSelector, handle) {
  var source = document.querySelector(sourceSelector);
  var els = getCollectionUtilsModalEls();

  if (!source || !els || !els.content) {
    return;
  }

  if (collectionUtilsModal.source) {
    closeCollectionUtilsModal();
  }

  hideCollectionUtilsProxy();
  collectionUtilsModal.source = source;
  collectionUtilsModal.handle = handle;
  moveCollectionUtilsModalNodes(source, els.content);
  els.modal.classList.add('modal--' + handle);
  document.body.classList.add('modal-loaded', 'modal-visible');
  document.body.style.overflow = 'hidden';
  positionCollectionUtilsModal();
}

function onCollectionUtilsModalClick(event) {
  var els = getCollectionUtilsModalEls();

  if (!els || !collectionUtilsModal.source) {
    return;
  }

  if (event.target.closest('[data-modal-close]')) {
    event.preventDefault();
    closeCollectionUtilsModal();
    return;
  }

  var sortButton = event.target.closest('[data-productgrid-trigger-sort-button]');

  if (sortButton) {
    event.preventDefault();
    var params = new URLSearchParams(window.location.search);
    params.set('sort_by', sortButton.value);
    params.delete('page');
    window.location.search = params.toString();
    return;
  }

  if (event.target === els.modal) {
    closeCollectionUtilsModal();
  }
}

function initCollectionUtilsModals() {
  var els = getCollectionUtilsModalEls();

  if (!els) {
    return;
  }

  document.querySelectorAll('[data-productgrid-trigger-filters]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (document.body.classList.contains('modal-visible')) {
        return;
      }

      openCollectionUtilsModal('[data-productgrid-sidebar]', 'productgrid-sidebar');
    });
  });

  document.querySelectorAll('[data-productgrid-modal-sort]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (document.body.classList.contains('modal-visible')) {
        return;
      }

      openCollectionUtilsModal('[data-productgrid-sort-content]', 'productgrid-sort');
    });
  });

  document.querySelectorAll('.utils-viewtoggle-button[data-collection-view]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();

      if (button.classList.contains('active')) {
        return;
      }

      var view = button.getAttribute('data-collection-view');

      if (!view) {
        return;
      }

      var params = new URLSearchParams(window.location.search);
      params.set('grid_list', view);
      params.delete('page');
      window.location.search = params.toString();
    });
  });

  els.modal.addEventListener('click', onCollectionUtilsModalClick);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && collectionUtilsModal.source) {
      closeCollectionUtilsModal();
    }
  });
}

function initKlaviyoOverlayRelease() {
  if (isCollectionPage()) {
    return;
  }

  releaseHiddenKlaviyoOverlay();
  window.setTimeout(releaseHiddenKlaviyoOverlay, 400);
  window.setTimeout(releaseHiddenKlaviyoOverlay, 1500);
  window.setInterval(releaseHiddenKlaviyoOverlay, 1000);

  if (!document.body) {
    return;
  }

  var klaviyoOverlayTimer = null;
  var observer = new MutationObserver(function () {
    if (klaviyoOverlayTimer) {
      window.clearTimeout(klaviyoOverlayTimer);
    }

    klaviyoOverlayTimer = window.setTimeout(releaseHiddenKlaviyoOverlay, 50);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class', 'aria-hidden']
  });
}

// 🔄 Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  var theme = window.Theme || {};
  syncHubRecentProductsToEmpire(theme);
  trackCurrentProductPageView();
  runHomepageProductBlockSwapWhenReady();
  initStickyCollectionUtils();
  initBlockKlaviyoPopupsOnCollections();
  initKlaviyoOverlayRelease();
  initCollectionUtilsModals();

  if (window.innerWidth <= 990) {
  new MyCartHandler();
  }
});


function scrollCarouselLeft() {
  document.getElementById("carousel").scrollBy({ left: -220, behavior: 'smooth' });
}

function scrollCarouselRight() {
  document.getElementById("carousel").scrollBy({ left: 220, behavior: 'smooth' });
}

function positionWishlistHeaderIcon() {
  var monk = document.getElementById('mrw-div-embedded-wishlist-header-container-0');
  var slot = document.querySelector('[data-wishlist-header-slot]');

  if (!monk || !slot) {
    return;
  }

  if (monk.parentElement !== slot) {
    slot.appendChild(monk);
  }

  monk.classList.add('site-header-wishlist');
}

function simplifyWishlistPageLayout() {
  if (!window.location.pathname.match(/\/pages\/wishlist\/?$/)) {
    return;
  }

  if (document.querySelector('.wishlist--section')) {
    return;
  }

  document.querySelectorAll('[id^="shopify-section-template"]').forEach(function (section) {
    section.style.display = 'none';
  });
}

function buildGuestBannerParagraph(container, loginUrl) {
  var text = container.textContent.replace(/\s+/g, ' ').trim();

  if (!text) {
    text = "You're viewing the wishlist as a guest user. Sign in to save your wishlist for later and access it across devices.";
  }

  var match = text.match(/^(.*?\bguest user\.)\s*Sign in\s*(.*)$/i);

  container.textContent = '';

  if (!match) {
    container.textContent = text;
    return;
  }

  container.appendChild(document.createTextNode(match[1] + ' '));

  var link = document.createElement('a');
  link.href = loginUrl;
  link.textContent = 'Sign in';
  container.appendChild(link);
  container.appendChild(document.createTextNode(' ' + match[2]));
}

function enhanceGuestBanner(page) {
  var banner = page.querySelector('.mrw-wishlist-page__guest-banner, .mrw-wishlist-guest-banner');
  if (!banner) {
    return;
  }

  var loginUrl = (window.Theme && window.Theme.routes && window.Theme.routes.account_login_url) || '/account/login';
  var linkedText = banner.querySelector('mrw-linked-text.mrw-wishlist-page__guest-banner-text, .mrw-wishlist-page__guest-banner-text');
  var paragraph = banner.querySelector(':scope > p');

  if (banner.dataset.themeGuestEnhanced === 'true') {
    if (paragraph && paragraph.querySelector('a') && paragraph.textContent.trim()) {
      return;
    }

    banner.dataset.themeGuestEnhanced = '';
  }

  if (linkedText) {
    paragraph = document.createElement('p');
    buildGuestBannerParagraph(paragraph, loginUrl);
    linkedText.replaceWith(paragraph);
    banner.dataset.themeGuestEnhanced = 'true';
    return;
  }

  if (paragraph && !paragraph.querySelector('a')) {
    buildGuestBannerParagraph(paragraph, loginUrl);
    banner.dataset.themeGuestEnhanced = 'true';
  }
}

function enhanceWishlistShareButton(page) {
  var shareEl = page.querySelector('.mrw-wishlist-page__share-btn');
  if (!shareEl) {
    return;
  }

  shareEl.querySelectorAll('mrw-icon').forEach(function (monkIcon) {
    monkIcon.remove();
  });

  if (!shareEl.querySelector('.wishlist-share-icon')) {
    var shareIcon = document.createElement('span');
    shareIcon.className = 'wishlist-share-icon';
    shareIcon.setAttribute('aria-hidden', 'true');
    shareIcon.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="#ffffff" aria-hidden="true"><path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z"></path></svg>';

    var shareText = shareEl.querySelector('mrw-text');
    if (shareText) {
      shareEl.insertBefore(shareIcon, shareText);
    } else {
      shareEl.insertBefore(shareIcon, shareEl.firstChild);
    }
  }

  var shareLabel = shareEl.querySelector('mrw-text');
  if (shareLabel && !shareLabel.dataset.themeShareLabelStyled) {
    shareLabel.style.color = '#ffffff';
    shareLabel.dataset.themeShareLabelStyled = 'true';
  }
}

var wishlistRatingCache = {};

function getProductHandleFromCard(card) {
  var link = card.querySelector('.mrw-product-card__image-link, a[href*="/products/"]');
  if (!link) {
    return null;
  }

  var href = link.getAttribute('href');
  var match = href && href.match(/\/products\/([^/?#]+)/);
  return match ? match[1] : null;
}

function roundRatingValue(value, scaleMax) {
  return Math.round((value * 10) / scaleMax) / 2;
}

function buildRatingMarkup(rating, scaleMax, count) {
  var scaled = roundRatingValue(rating, scaleMax);
  var stars = '';
  var index;

  for (index = 1; index <= 5; index++) {
    stars += '<svg class="rating__star rating__star-' + index + '" aria-hidden="true" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="3 3 17 17"><use clip-path="url(#icon-star-clip)" xlink:href="#icon-star"></use></svg>';
  }

  var countLabel = count === 1 ? '1 Review' : count + ' Reviews';

  return '<div class="product__rating rating wishlist-product-rating">' +
    '<div class="rating__star-wrapper" style="--rating-value:' + scaled + ';" role="img" aria-label="' + rating + ' out of ' + scaleMax + ' stars">' +
    stars +
    '</div>' +
    '<p class="rating__count"><span aria-hidden="true">' + countLabel + '</span></p>' +
    '</div>';
}

function parseRatingFromProductHtml(html) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(html, 'text/html');
  var shopifyRating = doc.querySelector('.product__rating.rating');

  if (shopifyRating && shopifyRating.querySelector('.rating__star-wrapper')) {
    return shopifyRating.outerHTML;
  }

  var jdgm = doc.querySelector('[data-average-rating][data-number-of-reviews]');
  if (!jdgm) {
    return null;
  }

  var average = parseFloat(jdgm.getAttribute('data-average-rating'));
  var count = parseInt(jdgm.getAttribute('data-number-of-reviews'), 10);

  if (!average || !count) {
    return null;
  }

  return buildRatingMarkup(average, 5, count);
}

function fetchProductRatingMarkup(handle) {
  if (Object.prototype.hasOwnProperty.call(wishlistRatingCache, handle)) {
    return Promise.resolve(wishlistRatingCache[handle]);
  }

  return fetch('/products/' + handle)
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      var markup = parseRatingFromProductHtml(html);
      wishlistRatingCache[handle] = markup;
      return markup;
    })
    .catch(function () {
      wishlistRatingCache[handle] = null;
      return null;
    });
}

function enhanceWishlistProductRatings(page) {
  page.querySelectorAll('mrw-wishlist-product-card').forEach(function (card) {
    if (card.dataset.themeRatingLoaded === 'loading' || card.dataset.themeRatingLoaded === 'done') {
      return;
    }

    var info = card.querySelector('.mrw-product-card__info');
    var title = card.querySelector('.mrw-product-card__title');

    if (!info || !title) {
      return;
    }

    if (info.querySelector('.wishlist-product-rating-slot, .wishlist-product-rating, .product__rating')) {
      card.dataset.themeRatingLoaded = 'done';
      return;
    }

    var handle = getProductHandleFromCard(card);
    if (!handle) {
      return;
    }

    card.dataset.themeRatingLoaded = 'loading';

    fetchProductRatingMarkup(handle).then(function (markup) {
      if (!markup || !card.isConnected) {
        card.dataset.themeRatingLoaded = 'done';
        return;
      }

      var slot = document.createElement('div');
      slot.className = 'wishlist-product-rating-slot';
      slot.innerHTML = markup;

      var currentTitle = card.querySelector('.mrw-product-card__title');
      if (currentTitle && currentTitle.parentElement) {
        currentTitle.parentElement.insertBefore(slot, currentTitle);
      }

      card.dataset.themeRatingLoaded = 'done';
    });
  });
}

function enhanceWishlistSoldOutButtons(page) {
  page.querySelectorAll('.mrw-product-card__atc[disabled], .mrw-product-card__atc[aria-disabled="true"]').forEach(function (atc) {
    var label = atc.querySelector('mrw-text');
    if (label && label.textContent.trim() !== 'Sold out') {
      label.textContent = 'Sold out';
    }
  });
}

function enhanceWishlistPage() {
  if (!window.location.pathname.match(/\/pages\/wishlist\/?$/)) {
    return;
  }

  var page = document.querySelector('mrw-wishlist-page, .mrw-wishlist-page');
  if (!page) {
    return;
  }

  var header = page.querySelector('.mrw-wishlist-page__header, .mrw-wishlist-page-header');
  if (header && !header.dataset.themeEnhanced) {
    var titleEl = header.querySelector('.mrw-wishlist-page__title');
    var shareEl = header.querySelector('.mrw-wishlist-page__share-btn');
    var titleText = titleEl ? titleEl.textContent.trim() : 'My Wishlist';

    var cartHeader = document.createElement('header');
    cartHeader.className = 'cart-title';

    var left = document.createElement('div');
    left.className = 'cart-title-left';

    var h1 = document.createElement('h1');
    h1.textContent = titleText;
    left.appendChild(h1);
    cartHeader.appendChild(left);

    if (shareEl) {
      var right = document.createElement('div');
      right.className = 'cart-title-right';
      shareEl.classList.add('button-primary', 'cart-title-button');

      var shareInnerBtn = shareEl.querySelector('.mrw-button');
      if (shareInnerBtn) {
        shareInnerBtn.classList.add('button-primary');
      }

      right.appendChild(shareEl);
      cartHeader.appendChild(right);
    }

    header.dataset.themeEnhanced = 'true';
    header.innerHTML = '';
    header.appendChild(cartHeader);
  }

  enhanceGuestBanner(page);
  enhanceWishlistShareButton(page);
  enhanceWishlistProductRatings(page);

  var emptySub = page.querySelector('.mrw-wishlist-page__empty-sub');
  if (emptySub && emptySub.tagName !== 'P' && !emptySub.dataset.themeEnhanced) {
    var emptyParagraph = document.createElement('p');
    emptyParagraph.textContent = emptySub.textContent.trim();
    emptySub.dataset.themeEnhanced = 'true';
    emptySub.replaceWith(emptyParagraph);
  }

  page.querySelectorAll('.mrw-product-card__atc').forEach(function (atc) {
    if (atc.dataset.themeAtcEnhanced === 'true') {
      return;
    }

    atc.classList.add('button-primary');

    var innerBtn = atc.querySelector('.mrw-button');
    if (innerBtn) {
      innerBtn.classList.add('button-primary');
    }

    atc.dataset.themeAtcEnhanced = 'true';
  });

  enhanceWishlistSoldOutButtons(page);

  page.querySelectorAll('.mrw-product-card__title').forEach(function (title) {
    if (title.dataset.themeTitleWrapped === 'true') {
      return;
    }

    title.style.whiteSpace = 'normal';
    title.style.overflow = 'visible';
    title.style.textOverflow = 'unset';
    title.style.minHeight = '0';
    title.dataset.themeTitleWrapped = 'true';
  });
}

function isLayoutHubProductPage() {
  return document.body.classList.contains('template-product') &&
    document.querySelector('.lh-product-form') &&
    !document.querySelector('form[data-product-form]');
}

function injectLayoutHubWishlistSlot() {
  if (!isLayoutHubProductPage()) {
    return;
  }

  var form = document.querySelector('.lh-product-form');
  if (!form || form.querySelector('#mrw-div-embedded-wishlist-button-container')) {
    return;
  }

  var slot = document.createElement('div');
  slot.id = 'mrw-div-embedded-wishlist-button-container';
  slot.className = 'layouthub-wishlist-monk-slot';

  var legacyWishlist = form.querySelector('.lh-add-wishlist');
  if (legacyWishlist) {
    legacyWishlist.replaceWith(slot);
    return;
  }

  var cartGroup = form.querySelector('.lh-cart-button-group .cart-form, .lh-cart-button-group');
  if (cartGroup) {
    cartGroup.insertBefore(slot, cartGroup.firstChild);
  }
}

function positionLayoutHubMonkWishlistButton() {
  if (!isLayoutHubProductPage()) {
    return;
  }

  var slot = document.querySelector('.lh-product-form .layouthub-wishlist-monk-slot');
  if (!slot || slot.querySelector('mrw-wishlist-button')) {
    return;
  }

  var candidates = document.querySelectorAll('.lh-product-form mrw-wishlist-button, body.template-product > mrw-wishlist-button, main mrw-wishlist-button');
  var index;

  for (index = 0; index < candidates.length; index++) {
    var button = candidates[index];

    if (button.closest('.site-header-wishlist, mrw-wishlist-product-card, .mrw-wishlist-page')) {
      continue;
    }

    if (button.parentElement === slot) {
      continue;
    }

    slot.appendChild(button);
    return;
  }
}

function inlineLayoutHubProductActions() {
  if (!isLayoutHubProductPage()) {
    return;
  }

  var form = document.querySelector('.lh-product-form');
  if (!form || form.dataset.themeInlineActions === 'true') {
    return;
  }

  var btnGroup = form.querySelector('.lh-btn-group');
  var atc = form.querySelector('.lh-add_to_cart');
  var quantity = form.querySelector('.lh-quantity');
  var slot = form.querySelector('.layouthub-wishlist-monk-slot');

  if (!btnGroup || !atc || !quantity) {
    return;
  }

  var row = document.createElement('div');
  row.className = 'layouthub-product-action-row';

  row.appendChild(quantity);
  row.appendChild(atc);

  if (slot) {
    row.appendChild(slot);
  }

  btnGroup.innerHTML = '';
  btnGroup.classList.add('layouthub-product-action-row-host');
  btnGroup.appendChild(row);

  form.dataset.themeInlineActions = 'true';
}

function resetLayoutHubAddToCartLabel(label) {
  label.style.setProperty('background', 'none', 'important');
  label.style.setProperty('background-color', 'transparent', 'important');
  label.style.setProperty('display', 'inline', 'important');
  label.style.setProperty('width', 'auto', 'important');
  label.style.setProperty('max-width', 'none', 'important');
  label.style.setProperty('height', 'auto', 'important');
  label.style.setProperty('min-height', '0', 'important');
  label.style.setProperty('padding', '0', 'important');
  label.style.setProperty('margin', '0', 'important');
  label.style.setProperty('flex', 'none', 'important');
  label.style.setProperty('align-items', 'unset', 'important');
  label.style.setProperty('justify-content', 'unset', 'important');
}

function enhanceLayoutHubProductButtons() {
  if (!isLayoutHubProductPage()) {
    return;
  }

  injectLayoutHubWishlistSlot();
  inlineLayoutHubProductActions();
  positionLayoutHubMonkWishlistButton();

  document.querySelectorAll('.lh-product-form .AddToCartText-product-template').forEach(function (label) {
    resetLayoutHubAddToCartLabel(label);

    if (label.dataset.themeLhAtcLabeled === 'true') {
      return;
    }

    var text = label.textContent.trim();

    if (text === 'ADD TO CART') {
      label.textContent = 'Add to cart';
    } else if (text === 'SOLD OUT') {
      label.textContent = 'Sold out';
    }

    label.dataset.themeLhAtcLabeled = 'true';
  });
}

function initWishlistMonkThemeHelpers() {
  enhanceLayoutHubProductButtons();
  positionWishlistHeaderIcon();
  simplifyWishlistPageLayout();
  enhanceWishlistPage();
}

document.addEventListener('DOMContentLoaded', initWishlistMonkThemeHelpers);

var wishlistMonkEnhanceTimer = null;

function runWishlistMonkEnhancements() {
  enhanceLayoutHubProductButtons();
  positionWishlistHeaderIcon();
  simplifyWishlistPageLayout();
  enhanceWishlistPage();
}

function scheduleWishlistMonkEnhancements() {
  if (wishlistMonkEnhanceTimer) {
    clearTimeout(wishlistMonkEnhanceTimer);
  }

  wishlistMonkEnhanceTimer = setTimeout(function () {
    wishlistMonkEnhanceTimer = null;
    runWishlistMonkEnhancements();
  }, 100);
}

var wishlistMonkObserver = new MutationObserver(scheduleWishlistMonkEnhancements);

wishlistMonkObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});

if (document.body) {
  enhanceLayoutHubProductButtons();
}

